export const routes = {
  community: {
    detail: (id: string) => `/communities/${id}/members`,
    list: '/communities',
  },
  dataManagement: {
    organization: (id: string) => `/data-management/organizations/${id}/featured-wla-programs`,
  },
  giving: {
    detail: (id: string) => `/givings/${id}/settings`,
    list: '/givings',
  },
  index: '/',
  organization: {
    list: '/organizations',
  },
  program: {
    detail: (id: string) => `/programs/${id}/settings`,
    list: '/programs',
  },
  tokenLogin: '/token-login',
  user: {
    detail: (id: string) => `/users/${id}`,
  },
};
